export default "<p>\n  employeet-dashboard works!\n</p>\n";